<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.staffNumber" clearable placeholder="编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.staffName" clearable placeholder="姓名" style="width:160px" @keyup.enter.native="search" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="staffNumber" label="编码" width="140" />
      <el-table-column label="姓名" min-width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ displayName(row) }}</template>
      </el-table-column>
      <el-table-column prop="divisionName" label="车间" width="120" show-overflow-tooltip />
      <el-table-column prop="crewName" label="班组" width="120" show-overflow-tooltip />
      <el-table-column prop="wageGroupName" label="工资组" width="120" show-overflow-tooltip />
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">启用</el-tag>
          <el-tag v-else size="mini" type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row.staffId)">修改</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.staffId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="form.staffId ? '修改员工' : '新增员工'" :visible.sync="visible" width="720px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="工号" prop="staffNumber">
          <el-input v-model="form.staffNumber" />
        </el-form-item>
        <el-form-item label="姓名" prop="staffName">
          <el-input v-model="form.staffName" />
        </el-form-item>
        <el-form-item label="岗位">
          <el-input v-model="form.post" />
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="form.email" />
        </el-form-item>
        <el-form-item label="所属公司">
          <el-select v-model="form.companyId" clearable filterable style="width:100%" placeholder="可选，维护页后续开放">
            <el-option v-for="i in companyOptions" :key="i.companyId" :label="i.companyName" :value="i.companyId" />
          </el-select>
        </el-form-item>
        <el-form-item label="车间">
          <el-select v-model="form.divisionId" clearable filterable style="width:100%">
            <el-option v-for="i in divisionOptions" :key="i.divisionId" :label="i.divisionName" :value="i.divisionId" />
          </el-select>
        </el-form-item>
        <el-form-item label="工资组">
          <el-select v-model="form.wageGroupId" clearable filterable style="width:100%" placeholder="可选，维护页后续开放">
            <el-option
              v-for="i in wageGroupOptions"
              :key="i.wageGroupId"
              :label="i.wageGroupName + ' / ' + (i.laborHourlyCost || 0)"
              :value="i.wageGroupId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="班组">
          <el-select v-model="form.crewId" clearable filterable style="width:100%" placeholder="可选，维护页后续开放">
            <el-option
              v-for="i in crewOptions"
              :key="i.crewId"
              :label="(i.crewNumber || '') + ' ' + (i.crewName || '')"
              :value="i.crewId"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="启用">
          <el-switch v-model="form.active" active-value="1" inactive-value="0" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import {
  listStaff, getStaff, saveStaff, updateStaff, deleteStaff,
  selectCompany, selectWageGroup, selectCrew
} from '../../api/staff'
import { selectDivision } from '../../api/division'

function emptyForm() {
  return {
    staffId: '',
    staffNumber: '',
    staffName: '',
    email: '',
    phone: '',
    post: '',
    companyId: '',
    divisionId: '',
    workstationId: '',
    wageGroupId: '',
    crewId: '',
    active: '1'
  }
}

export default {
  name: 'MesStaffPage',
  components: { ListPagination },
  data() {
    return {
      query: { staffNumber: '', staffName: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      visible: false,
      saving: false,
      form: emptyForm(),
      companyOptions: [],
      divisionOptions: [],
      wageGroupOptions: [],
      crewOptions: [],
      rules: {
        staffNumber: [{ required: true, message: '编码不能为空', trigger: 'blur' }],
        staffName: [{ required: true, message: '姓名不能为空', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    displayName(row) {
      const sur = (row && row.surname ? row.surname : '').trim()
      const name = (row && row.staffName ? row.staffName : '').trim()
      if (!sur) return name
      if (!name || name.startsWith(sur)) return name || sur
      return sur + name
    },
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listStaff({
        currentPage: this.page,
        pageSize: this.pageSize,
        staffNumber: this.query.staffNumber,
        staffName: this.query.staffName
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    loadOptions() {
      selectCompany().then(res => { this.companyOptions = res.data || [] }).catch(() => { this.companyOptions = [] })
      selectDivision().then(res => { this.divisionOptions = res.data || [] }).catch(() => { this.divisionOptions = [] })
      selectWageGroup().then(res => { this.wageGroupOptions = res.data || [] }).catch(() => { this.wageGroupOptions = [] })
      selectCrew().then(res => { this.crewOptions = res.data || [] }).catch(() => { this.crewOptions = [] })
    },
    openEdit(id) {
      this.form = emptyForm()
      this.loadOptions()
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (!id) return
      getStaff(id).then(res => {
        const data = res.data || {}
        this.form = Object.assign(emptyForm(), data, {
          staffName: this.displayName(data),
          surname: ''
        })
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        const payload = Object.assign({}, this.form, { surname: '' })
        const req = payload.staffId ? updateStaff(payload) : saveStaff(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.visible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(i => i.staffId)
      if (!ids.length) return
      this.$confirm('确定删除?', '提示', { type: 'warning' }).then(() => {
        deleteStaff(ids).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
